import ChatLeftNav from './ChatLeftNav'

const ChatLeftNavContainer = () => {
  return (
    <aside class="hidden border-r border-r-cosplay-gray-100 bg-cosplay-gray-900 md:mt-[82px] md:h-[calc(100vh-82px)] lg:fixed lg:block">
      <ChatLeftNav />
    </aside>
  )
}

export default ChatLeftNavContainer
